import { render, staticRenderFns } from "./rightT-temp3.vue?vue&type=template&id=4db3cc84&scoped=true"
import script from "./rightT-temp3.vue?vue&type=script&lang=js"
export * from "./rightT-temp3.vue?vue&type=script&lang=js"
import style0 from "./rightT-temp3.vue?vue&type=style&index=0&id=4db3cc84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db3cc84",
  null
  
)

export default component.exports